import theme from 'config/theme';
import {Button} from 'interface/base/Button';
import {Icon} from 'interface/base/Icon';
import type {ActionButtonProps} from 'interface/stacks/content-viewer/components/ActionButton';
import React, {forwardRef} from 'react';
import {type StyleProp, StyleSheet, type ViewStyle} from 'react-native';

interface Props extends ActionButtonProps {
  iconName: string;
  iconStyle?: StyleProp<ViewStyle>;
}

const CircleButton = forwardRef<any, Props>(
  ({iconName, iconStyle, ...rest}, ref) => {
    return (
      <Button
        overrides={{
          Button: {
            style: styles.button,
          },
        }}
        variant="text"
        startEnhancer={
          <Icon
            overrides={{
              style: iconStyle,
            }}
            name={iconName}
            size={20}
          />
        }
        ref={ref}
        {...rest}
      />
    );
  },
);

const styles = StyleSheet.create({
  button: {
    borderColor: theme.colors.neutral.$10,
    borderRadius: 50,
    maxWidth: 32,
  },
});

export default CircleButton;
